import Route from '@ember/routing/route';

export default class CareerPathwaysLrapRoute extends Route {}
